var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/nodes/grid/grid-cell/node-grid-cell.ts
import { ModeConsumer } from "@adornis/buildify/client/globals/consumer.js";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { updateNodeAttrs } from "../../../util.js";
var NodeGridCell = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this._consumedMode = ModeConsumer(this);
  }
  // eslint-disable-next-line complexity
  updated(changedProperties) {
    super.updated(changedProperties);
    const grid = this.parentElement;
    if (!grid)
      return;
    const gridData = grid._constructedData.value;
    const tableView = gridData?.tableView;
    if (!tableView)
      return;
    this.thickness = tableView.thickness ?? "1px";
    this.color = tableView.colorSeperators ?? "#333";
    const gridColumnGap = gridData.gridColumnGap;
    const parsedGridColumnGap = Number.parseInt(gridColumnGap?.split("px")[0] ?? "");
    this.columnGap = parsedGridColumnGap;
    const gridRowGap = gridData.gridRowGap;
    const parsedGridRowGap = Number.parseInt(gridRowGap?.split("px")[0] ?? "");
    this.rowGap = parsedGridRowGap;
    if (!this.view || !this.getPos)
      return;
    const classList = ["grid-item"];
    const childrenArray = Array.from(grid.children);
    const index = childrenArray.indexOf(this);
    const columns = gridData.columns ?? 3;
    const rows = Math.ceil(childrenArray.length / columns);
    if (index < rows * columns - columns && tableView.hasHorizontalSeperator) {
      const column = index % columns;
      if (column === 0)
        classList.push("line-below-max-right");
      else if (column === columns - 1)
        classList.push("line-below-max-left");
      else {
        classList.push("line-below-max-right");
        classList.push("line-below-max-left");
      }
      classList.push("grid-line-below");
    }
    if (index % columns !== 0 && tableView.hasVerticalSeperator) {
      const row = Math.floor(index / columns);
      if (rows > 1) {
        if (row === 0)
          classList.push("line-left-max-bottom");
        else if (row === rows - 1)
          classList.push("line-left-max-top");
        else {
          classList.push("line-left-max-bottom");
          classList.push("line-left-max-top");
        }
      }
      classList.push("grid-line-left");
    }
    if (this.classList.length === classList.length && classList.every((item) => this.classList.contains(item)))
      return;
    const { state, dispatch } = this.view;
    const { tr } = state;
    updateNodeAttrs(
      state,
      tr,
      () => {
        return this.getPos() ?? 0;
      },
      { class: classList.join(" ") }
    );
    dispatch(tr);
  }
  render() {
    return html` <slot></slot> `;
  }
  isEditMode() {
    return this._consumedMode.value === "edit";
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          border: this.isEditMode() ? "1px solid grey" : "",
          position: "relative"
          //   overflowWrap: 'break-word',
        },
        ":host(.grid-item)": {
          position: "relative",
          overflow: "visible"
        },
        ":host(.grid-item) > *": {
          width: "100%"
        },
        ":host(.grid-item.child-container-item) > :first-child": {
          boxSizing: "border-box",
          height: "100%"
        },
        ":host(.grid-line-left)::before": {
          content: "''",
          position: "absolute",
          left: this.columnGap ? `-${this.columnGap / 2}px` : "0",
          top: "0",
          bottom: "0",
          width: this.thickness,
          background: this.color,
          zIndex: "10"
        },
        ":host(.grid-line-below)::after": {
          content: "''",
          position: "absolute",
          bottom: this.rowGap ? `-${this.rowGap / 2}px` : "0",
          height: this.thickness,
          background: this.color,
          left: "0",
          right: "0",
          zIndex: "10"
        },
        ":host(.grid-line-left.line-left-max-bottom)::before": {
          bottom: this.rowGap ? `-${this.rowGap / 2}px` : "0"
        },
        ":host(.grid-line-left.line-left-max-top)::before": {
          top: this.rowGap ? `-${this.rowGap / 2}px` : "0"
        },
        ":host(.grid-line-below.line-below-max-left)::after": {
          left: this.columnGap ? `-${this.columnGap / 2}px` : "0"
        },
        ":host(.grid-line-below.line-below-max-right)::after": {
          right: this.columnGap ? `-${this.columnGap / 2}px` : "0"
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], NodeGridCell.prototype, "view", 2);
__decorateClass([
  property({ attribute: false })
], NodeGridCell.prototype, "getPos", 2);
__decorateClass([
  property({ attribute: false })
], NodeGridCell.prototype, "thickness", 2);
__decorateClass([
  property({ attribute: false })
], NodeGridCell.prototype, "color", 2);
__decorateClass([
  property({ attribute: false })
], NodeGridCell.prototype, "rowGap", 2);
__decorateClass([
  property({ attribute: false })
], NodeGridCell.prototype, "columnGap", 2);
NodeGridCell = __decorateClass([
  customElement("node-grid-cell")
], NodeGridCell);
export {
  NodeGridCell
};
